<template>
  <v-navigation-drawer
    :value="true"
    fixed
    temporary
    right
    :width="$vuetify.breakpoint.lgAndUp ? '30%' : undefined"
    aria-labelledby="details-heading"
    @input="emitInput"
  >
    <div
      class="px-8 py-16"
    >
      <v-row>
        <v-col>
          <h2
            id="details-heading"
          >
            Share Holding
          </h2>
          <h3>
            Certificate Number {{ formattedHolding.certificateNumber }}
          </h3>
        </v-col>
      </v-row>
      <v-simple-table>
        <tbody>
          <tr
            v-for="(item, i) in propertiesToShow"
            :key="i"
          >
            <td v-if="formattedHolding[item[0]]">
              {{ item[1] }}
            </td>
            <td v-if="formattedHolding[item[0]]">
              {{ formattedHolding[item[0]] }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <slot
        name="actions"
        v-bind="holding"
      />
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'HoldingInfoPane',
  props: {
    holding: { type: Object, required: true }
  },
  data: () => {
    return {
      drawer: true,
      propertiesToShow: [
        ['name', 'Shareholder'],
        ['numberOfShares', 'No. Issued Shares'],
        ['amountInvested', 'Amount Invested'],
        ['percentage', 'Percentage'],
        ['email', 'Email'],
        ['address', 'Address'],
        ['dateIssued', 'Date Issued'],
        ['sharePrice', 'Share Price'],
        ['discountInCents', 'Discount (Cents)'],
        ['shareType', 'Type'],
        ['shareTypeClass', 'Class'],
        ['conditions', 'Conditions']
      ]
    }
  },
  computed: {
    formattedHolding() {
      const holding = { ...this.holding }
      holding.certificateNumber = String(holding.certificateNumber).padStart(3, '0')
      holding.percentage = (holding.percentage * 100).toFixed(2)
      holding.amountInvested = holding.amountInvested.toFixed(2)
      holding.sharePrice = Number(holding.sharePrice).toFixed(2)
      return holding
    }
  },
  methods: {
    emitInput(open) {
      if (open === false) {
        this.$emit('closed')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  text-transform: uppercase;
}
h3 {
  text-transform: uppercase;
  color: var(--v-darkgray-base);
}

</style>
